import router from '@/router'
import { createStore } from 'vuex';
import modules from './modules';
import { loginForStaff, loginForUser } from "@/api/login";
const store = createStore({
    modules,
    strict: process.env.NODE_ENV !== 'production',
    state: {
        isSidebarHidden: false,
        isMobileSidebarActive: false,
        isFixedWidth: false,
        token: localStorage.getItem('Token')
    },
    mutations: {
        toggleSidebar(state) {
            state.isSidebarHidden = !state.isSidebarHidden;
        },
        toggleMobileSidebar(state) {
            state.isMobileSidebarActive = !state.isMobileSidebarActive;
        },
        setFullWidth(state) {
            state.isFixedWidth = false;
        },
        setFixedWidth(state) {
            state.isFixedWidth = true;
        },
        changeLayoutType(state, payload) {
            state.layoutType = payload.layoutType;
        },
        SET_TOKEN(state, token) {
            state.token = token
        },
    },
    getters: {
        isFixedWidth: state => state.isFixedWidth,
    },
    actions: {
        changeLogin({ commit }, userInfo) {
            let requestUrl;
            if (process.env.VUE_APP_ADDRESS === 'pro') {
                requestUrl = loginForStaff(userInfo)
            } else {
                requestUrl = loginForUser(userInfo)
            }
            return new Promise((resolve, reject) => {
                requestUrl.then(response => {
                    if (response.success) {
                        const result = response.obj
                        localStorage.setItem('Token', result)
                        commit('SET_TOKEN', result);
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeLogout({ commit }) {
            localStorage.removeItem('Token')
            localStorage.removeItem('username')
            localStorage.removeItem('remember')
            localStorage.removeItem('role')
            commit('SET_TOKEN', null)
            let url;
            if (process.env.VUE_APP_ADDRESS === 'pro') {
                url = "/login"
            } else {
                url = "/userLogin"
            }
            router.push(url)
        },
    }
});

export default store;
